export default "__VITE_ASSET__ViZWv90k__"